<template>
  <ModernSelect
    :value="value"
    :options="options"
    :disabled="userTypeIds === null || userTypeIds.length < 1"
    style="min-width: 150px;"
    @input="onValueChange"
  />
</template>

<script>

import ModernSelect from '@/components/ModernSelect.vue';

const anyOption = { value: null, label: 'Any' };
export default {
  components: {
    ModernSelect,
  },
  name: 'ThemeSelect',
  props: {
    value: {
      default: null,
    },
    themes: {
      type: Array,
      default: () => [],
    },
    userTypeIds: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    stringToIntegerArray(value) {
      if (!value?.trim()) {
        return [];
      }

      return value
        .split(',')
        .map((item) => Number.parseInt(item.trim(), 10))
        .filter(Number.isInteger);
    },
    onValueChange(newValue) {
      this.$emit('input', this.stringToIntegerArray(newValue));
    },
  },
  computed: {
    options() {
      if (this.userTypeIds === null) {
        return [anyOption];
      }

      const themesByUserTypeIds = this.themes
        .filter((item) => this.userTypeIds.includes(item.userType.id));

      const preparedThemesMappedByName = {};
      themesByUserTypeIds.forEach((item) => {
        if (preparedThemesMappedByName[item.name]) {
          preparedThemesMappedByName[item.name].value.push(item.id);
        } else {
          preparedThemesMappedByName[item.name] = {
            value: [item.id],
            label: item.name,
          };
        }
      });

      const sortedThemes = [...Object.values(preparedThemesMappedByName)].sort((a, b) => {
        const pinnedDiff = Number(b.isPinned) - Number(a.isPinned);

        if (pinnedDiff !== 0) {
          return pinnedDiff;
        }

        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();

        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;

        return 0;
      });

      return [anyOption, ...sortedThemes];
    },
  },
};
</script>
